import { AuthenticationService } from './../services/auth.service'
import { Component, Input } from '@angular/core'
import { Constants } from '../common/config/constants'

@Component({
  standalone: false,
  selector: 'app-user-dialog',
  templateUrl: './user-dialog.component.html',
  styleUrls: ['./user-dialog.component.scss'],
})
export class UserDialogComponent {
  @Input() data: any = {}
  @Input() avatar = ''
  logo = Constants.logo

  constructor(private auth: AuthenticationService) {}

  get userName() {
    const authData = this.auth.getUser()
    return authData?.account_name || '-'
  }

  logout() {
    this.auth.logout()
  }
}
